module.exports = __webpack_public_path__ + "img/certificate-CU-Pre.dce0b8d7.jpg";